<template>
	<div class="modal modal-blur fade" id="modal-report" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog modal-lg modal-dialog-centered" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<h5 class="modal-title">Set Remark Comment</h5>
					<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-lg-12">
							<div>
								<label class="form-label">Remarks</label>
								<textarea class="form-control" rows="5"></textarea>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button class="btn link-secondary" data-bs-dismiss="modal">
						Cancel
					</button>
					<button class="btn btn-primary ms-auto">
						Submit
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['data'], 
		data() {
			return {

			};
		},
		mounted() {
		},
		methods: {

		},
	}
</script>